angular
  .module('contrast.services.report', [])
  .factory('ReportService', function ($translate) {
    'ngInject'

    return {
      getAvailableReports: function () {
        return [
          { value: 'owasp-2013', text: 'OWASP 2013 Top 10' },
          { value: 'owasp-2017', text: 'OWASP 2017 Top 10' },
          { value: 'owasp-2021', text: 'OWASP 2021 Top 10' },
          {
            value: 'owasp-api-security-2019',
            text: 'OWASP Top 10 API Vulnerabilities 2019'
          },
          { value: 'disa', text: 'DISA ASD STIG' },
          { value: 'pci-2.0', text: 'PCI DSS - 2.0' },
          { value: 'pci-3.0', text: 'PCI DSS - 3.0' },
          { value: 'pci-3.2.1', text: 'PCI DSS - 3.2.1' },
          { value: 'pci-4.0', text: 'PCI DSS - 4.0' }
        ]
      },
      getAvailableTraceSeverities: function () {
        return [
          {
            value: 'CRITICAL',
            text: $translate.instant('title_vulnSeverityTypeCritical'),
            group: 'SEVERITY'
          },
          {
            value: 'HIGH',
            text: $translate.instant('title_vulnSeverityTypeHigh'),
            group: 'SEVERITY'
          },
          {
            value: 'MEDIUM',
            text: $translate.instant('title_vulnSeverityTypeMedium'),
            group: 'SEVERITY'
          },
          {
            value: 'LOW',
            text: $translate.instant('title_vulnSeverityTypeLow'),
            group: 'SEVERITY'
          },
          {
            value: 'NOTE',
            text: $translate.instant('title_vulnSeverityTypeNote'),
            group: 'SEVERITY'
          }
        ]
      },
      getTraceStatus: function () {
        var transl = {
          title_vulnerabilityStatusFixed: $translate.instant(
            'title_vulnerabilityStatusFixed'
          ),
          title_vulnerabilityStatusReported: $translate.instant(
            'title_vulnerabilityStatusReported'
          ),
          title_vulnerabilityStatusRemediated: $translate.instant(
            'title_vulnerabilityStatusRemediated'
          ),
          title_vulnerabilityStatusNotProblem: $translate.instant(
            'title_vulnerabilityStatusNotProblem'
          ),
          title_vulnerabilityStatusSuspicious: $translate.instant(
            'title_vulnerabilityStatusSuspicious'
          ),
          title_vulnerabilityStatusConfirmed: $translate.instant(
            'title_vulnerabilityStatusConfirmed'
          )
        }

        return [
          {
            value: 'Confirmed',
            text: transl.title_vulnerabilityStatusConfirmed,
            group: 'STATUS'
          },
          {
            value: 'Suspicious',
            text: transl.title_vulnerabilityStatusSuspicious,
            group: 'STATUS'
          },
          {
            value: 'NotAProblem',
            text: transl.title_vulnerabilityStatusNotProblem,
            group: 'STATUS'
          },
          {
            value: 'Remediated',
            text: transl.title_vulnerabilityStatusRemediated,
            group: 'STATUS'
          },
          {
            value: 'Reported',
            text: transl.title_vulnerabilityStatusReported,
            group: 'STATUS'
          },
          {
            value: 'Fixed',
            text: transl.title_vulnerabilityStatusFixed,
            group: 'STATUS'
          }
        ]
      },
      buildReportSettingsForm: function (
        settings,
        types,
        status,
        severities,
        tags
      ) {
        var form = {}
        form.selectedTypes = []
        form.selectedStatus = []
        form.selectedTags = []
        angular.forEach(settings.types, function (type) {
          angular.forEach(types, function (typeArray) {
            if (typeArray.value == type) {
              form.selectedTypes.push(typeArray)
            }
          })
        })
        angular.forEach(settings.status, function (statusSaved) {
          angular.forEach(status, function (statusArray) {
            if (statusArray.value == statusSaved) {
              form.selectedStatus.push(statusArray)
            }
          })
        })
        angular.forEach(settings.severities, function (severitiesSaved) {
          angular.forEach(severities, function (severitiesArray) {
            if (severitiesArray.value == severitiesSaved) {
              form.selectedStatus.push(severitiesArray)
            }
          })
        })
        angular.forEach(settings.tags, function (tagSaved) {
          angular.forEach(tags, function (tagArray) {
            if (tagArray.value == tagSaved) {
              form.selectedTags.push(tagArray)
            }
          })
        })

        form.includeStatus = settings.include_status
        form.includeNotes = settings.include_notes
        form.footer = settings.custom_footer

        return form
      }
    }
  })
